import * as React from 'react';
import { inject } from 'mobx-react';
import { ContextStore } from 'bernie-core';
import { UitkButtonSize } from 'uitk-react-button';
import { PrimaryFloatingButtonTracked, TertiaryButtonTracked } from 'components/shared';
import { ActionType } from 'types/shared';
import { FlightsActionDisplayType, FlightsActionType } from '__generated__/api';

export interface ChooseActionButtonButtonProps {
  action: ActionType;
  isFullWidth: boolean;
  handleActionSelection: (flightsActionType: FlightsActionType, e: Event | React.MouseEvent) => void;
  size: UitkButtonSize;
  context?: ContextStore;
  actionUrl?: string;
  testDataId?: string;
  disabled?: boolean;
  shouldNotTriggerAnalytics?: boolean;
}

export const ChooseActionButton = inject('context')(
  ({
    action: { type, displayAction, displayType, analytics },
    handleActionSelection,
    isFullWidth,
    size,
    context,
    actionUrl,
    testDataId,
    disabled,
    shouldNotTriggerAnalytics
  }: ChooseActionButtonButtonProps) => {
    const button = {
      text: displayAction,
      href: actionUrl,
      isFullWidth,
      size,
      ...analytics,
      onClick: handleActionSelection.bind(null, type),
      disabled
    };

    if (shouldNotTriggerAnalytics) {
      button.linkName = null;
      button.rfrr = null;
    }

    const Tag = displayType === FlightsActionDisplayType.PRIMARY ? PrimaryFloatingButtonTracked : TertiaryButtonTracked;

    return (
      <Tag
        {...button}
        target={context && context.deviceInformation && context.deviceInformation.mobile ? null : '_blank'}
        data-test-id={testDataId}
        rel="noopener"
      />
    );
  }
);
